export { default } from "./alarm.web";
